import axios from "axios";
const URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4040/"
    : "https://botaniksan.com/";
const endpointURL = "graphql";

export const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4040/graphql"
    : "https://botaniksan.com/graphql";

export const PUBLIC_DIR = (path) => {
  return `${URL + path.slice(9)}`;
};

export const API = (params) => `${URL + endpointURL}?${params}`;
export const API_POST = `${URL + endpointURL}`;
export const PUBLIC_URL = (url) => `${URL}${url.substr(9)}`;

// export const FETCH_GET = async query => await axios.get(API(query));
export const FETCH_GET = async (query, token = false) => {
  return await axios.get(API(query), { headers: buildHeaders(token) });
};

export const FILE_UPLOAD = async (formData, config) => {
  return await axios({
    baseURL: API_URL,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const FETCH_POST = async ({ query, variables }, token = false) => {
  return await axios.post(
    API_URL,
    {
      query,
      variables,
    },
    { headers: buildHeaders(token) }
  );
};

const buildHeaders = (token = false) => {
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `JWT ${token}`;

  return headers;
};



// WEBPACK FOOTER //
// ./src/config/index.js